module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Th.81a2492.ttf";